<template>
<div class="main" >
	<div class="banner" ref="info" @click="toBuy">
		<img src="../../images/tongxiangongren.jpg" alt="">
	</div>
	<div class="tabs" ref="tabs">
		<div class="tabs-container" :class="{fixed:fixed}">
			<Tabs :value="tabName" @on-click="tabChange">
				<TabPane label="产品介绍" name="info"></TabPane>
				<TabPane label="保障方案" name="case"></TabPane>
				<!-- <TabPane label="理赔流程" name="claim"></TabPane> -->
			</Tabs>
			<div class="tabs-container-form" v-show="fixed">
				<Button type="primary" @click="toBuy">立即购买</Button>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">产品介绍</div>
		<div class="detail-main">
			<div class="detail-main-text" ref="case">
				所有方案均需投保人员符合以下情况：<br />
				本产品要求被保险人无高空作业或者高空作业比例不超过1%，被保险人为与海尔员工同线生产，负责协调、生产辅助性工作(如装卸、包装、搬运等)工作的工人，投保年龄在16-60周岁之间，其他人员不承保。且本保险只承保被保险人在海尔工业园地理范围内发生的工作期间的事故，对于上下班途中非本人主要责任的交通事故本保险也承担保险责任。对于不符合本保险方案条件的人员和事故，本保险不承担赔偿责任。
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-title">保障方案</div>
		<div class="detail-main">
			<div class="center">
				<table class="productDetail-table">
					<thead>
						<th colspan="2" style="text-align: center;">方案</th>
						<th style="text-align: center;">方案一</th>
						<th style="text-align: center;">方案二</th>
						<th style="text-align: center;">方案三</th>
					</thead>
					<tbody>
						<tr class="hoverTr">
							<td colspan="2">保额</td>
							<td>100万</td>
							<td>50万</td>
							<td>20万</td>
						</tr>
					</tbody>
					<tbody class="hoverTr">
						<tr>
							<td rowspan="2">保费</td>
							<td>16-39周岁</td>
							<td>40元/人/月</td>
							<td>35元/人/月</td>
							<td>15元/人/月</td>
						</tr>
						<tr>
							<td>40-60周岁</td>
							<td>65元/人/月</td>
							<td>50元/人/月</td>
							<td>20元/人/月</td>
						</tr>
					</tbody>
					<tbody>
						<tr class="hoverTr">
							<td colspan="2">保险公司</td>
							<td>中国太平洋财产保险股份有限公司</td>
							<td>华泰财产保险有限公司</td>
							<td>华泰财产保险有限公司</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<div class="detail">
		<div class="detail-main">
			<div class="detail-main-text left"><b>产品条款查看：</b></div>
			<div style="font-size: 14px;text-align: left;padding-left: 20px; margin-bottom: 20px;">
				<p>
					<a href="/static/pdf/haierProduct/tongxian/同线工人雇主责任险特别约定.pdf" target="_blank" referrerpolicy="no-referrer">《同线工人雇主责任险特别约定》</a>
					<a href="/static/pdf/haierProduct/tongxian/华泰财产保险有限公司雇主责任险条款.pdf" target="_blank" referrerpolicy="no-referrer">《华泰财产保险有限公司雇主责任险条款》</a>
					<a href="/static/pdf/haierProduct/tongxian/太保雇主责任险特别约定.pdf" target="_blank" referrerpolicy="no-referrer">《太保雇主责任险特别约定》</a>
				</p>
			</div>
		</div>
	</div>
	<!-- <div class="detail">
		<div class="detail-title">理赔流程</div>
		<div class="detail-main">
			<div class="detail-main-text">
				<p>
					第一步，报案：发生事故后48小时内，拨打95510，接到报案后10分钟内电话联系客户，告知被保险人后续理赔处理流程。<br />
					第二步，现场查勘：理赔员在约定的时间内赶到事故现场完成对受损项目的查勘取证，并告知理赔资料清单。<br />
					第三步，资料收集：各仓小微按照要求准备理赔资料，提交给理赔员或公估人。<br />
					第四步，损失核定：沟通损失金额，达成一致赔付意见。<br />
					第五步，支付赔款：赔款支付至被保险人指定账户。
				</p>
			</div>
		</div>
		<br>
		<br>
	</div> -->
	<TrackNotice companyName="中国公司" />
</div>
</template>
<script>
import { mapState } from 'vuex'
import TrackNotice from '@/components/common/TrackNotice.vue';
import track from "@/mixin/track";
export default {
	components:{ TrackNotice },
	mixins:[ track ],
	data () {
		return {
			tabName:'info',
			fixed:false
		}
	},
	watch:{
		info(){
			this.checkLogin()
		}
	},
	computed:{
		...mapState({
			info:state=>state.common.info
		})
	},
	mounted() {
		//2023.8.7增加回溯逻辑
		this.track_is_new = true;
		this.$nextTick(()=>{
			window.addEventListener("scroll",this.handleScroll);
			this.trackInit(); 
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	created(){
	},
	methods:{
		checkLogin(){
			// 检测登录
			if(!this.info.userId){
				if(location.href&&location.href.indexOf('/common.html#/login')==-1){
					window.location = location.origin +'/common.html#/login?bankUrl='+encodeURIComponent(location.href);
				}
				return false
			}else{
				return true
			}
		},
		// 立即购买
		toBuy() {
			this.$axios.post('/casual/company').then((res) => {
				this.stopRecord({
					is_new: true
				}).then(()=>{
					this.$router.push(`/lineWork/fillin`)
				})
			})
		},
		getTimeState(){
			// 获取当前时间
			let timeNow = new Date();
			// 获取当前小时
			let hours = timeNow.getHours();
			// 设置默认文字
			let state= false;
			// 判断当前时间段
			if (hours > 21 && hours <= 24) {
				state= true;
			}
			return state;
		},
		// tab切换
		tabChange(val){
			this.$refs[val].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
			})
		},
		// 定位到伤残费率表位置
		toSC(key) {
			this.$refs[key].scrollIntoView({
				behavior: "smooth",  // 平滑过渡
	  	  		block:    "center"  // 上边框与视窗顶部平齐。默认值
			})
		},
		// 监听滚动
		handleScroll() {
			//获取滚动时的高度
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > this.$refs.tabs.offsetTop) {
				this.fixed=true;
			}else{
				this.fixed=false;
			}
		}
	}
}
</script>
<style scoped lang="less">
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
    .step-contain{
        display: flex;
        justify-content: space-between;
        .step-item{
            width: 26%;
        }

    }
    .step-con {
        margin-bottom: 20px;
    }
    .step-con .ivu-steps-item:last-child{
        flex: 1 !important;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/lineWork/index.vue